module.exports = __webpack_public_path__ + "media/images/partnor-f17cac24676ceb1e9ce66a3d53a86c2a.svg";